import {Component, property} from '@wonderlandengine/api';
import {vec3} from 'gl-matrix';

const tempVec = vec3.create();

export class JiggleComponent extends Component {
    static TypeName = 'jiggle';

    @property.float(5.0)
    jiggleSpeed = 5.0;

    @property.float(0.05)
    jiggleAmplitude = 0.05;

    private _originalPosition = vec3.create();
    private _elapsedTime = 0;
    private _duration = 0;
    private _isJiggling = false;

    public startJiggle(duration: number = 0): void {
        if (!this._isJiggling) {
            this.object.getPositionLocal(this._originalPosition);
            this._elapsedTime = 0;
            this._duration = duration;
            this._isJiggling = true;
        }
    }

    public stopJiggle(): void {
        if (this._isJiggling) {
            this._isJiggling = false;
            this.object.setPositionLocal(this._originalPosition);
        }
    }

    onDeactivate(): void {
        this.stopJiggle();
    }

    update(dt: number): void {
        if (!this._isJiggling) {
            return;
        }

        this._elapsedTime += dt;

        if (this._duration > 0 && this._elapsedTime >= this._duration) {
            this.stopJiggle();
            return;
        }

        const offsetX =
            Math.sin(this._elapsedTime * this.jiggleSpeed) * this.jiggleAmplitude;
        const offsetY =
            Math.sin((this._elapsedTime + 1) * this.jiggleSpeed * 1.1) *
            this.jiggleAmplitude;
        const offsetZ =
            Math.sin((this._elapsedTime + 2) * this.jiggleSpeed * 1.2) *
            this.jiggleAmplitude;

        vec3.set(
            tempVec,
            this._originalPosition[0] + offsetX,
            this._originalPosition[1] + offsetY,
            this._originalPosition[2] + offsetZ
        );

        this.object.setPositionLocal(tempVec);
    }
}
